export default __webpack_public_path__ + "static/GRID2022 Stock Conflict RGBlight - Simplify-01-fr-bc64857678f409cbbad17856fd4c423c.svg";